import { Button, Container, Group, Text, Title } from "@mantine/core";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";

/**
 * Error boundary di rotta: senza un errorElement qualunque eccezione di rendering
 * lasciava la pagina completamente bianca, senza modo di tornare indietro.
 */
function ErrorPage() {
    const error = useRouteError();
    const navigate = useNavigate();

    const isNotFound = isRouteErrorResponse(error) && error.status === 404;
    const detail = isRouteErrorResponse(error)
        ? error.statusText
        : error instanceof Error ? error.message : undefined;

    return (
        <Container size={520} my={80} ta="center">
            <Title order={1}>{isNotFound ? '404' : 'Errore'}</Title>
            <Text mt="md" c="dimmed">
                {isNotFound
                    ? 'La pagina che stai cercando non esiste.'
                    : 'Si è verificato un errore imprevisto.'}
            </Text>
            {detail && !isNotFound && <Text mt="xs" size="sm" c="dimmed">{detail}</Text>}
            <Group justify="center" mt="xl">
                <Button onClick={() => navigate('/home')}>Torna alla home</Button>
            </Group>
        </Container>
    );
}

export default ErrorPage;
